"use client";

import { ArrowRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState, useEffect } from "react";
import ClippedImageShape from "./ClippedImageShape";

const content = [
  {
    images: "/images/landing-1.jpg",
    text: "Your trusted partner for every legal challenge",
    link: "Our expertise",
    contentImage: "/images/landing-1.jpg",
    currentLink: "/expertise",
  },
  {
    images: "/images/cityy.webp",
    text: "Your Legal compass in a complex world",
    link: "About us",
    contentImage: "/images/mombasa.webp",
    currentLink: "/about-us",
  },
  {
    images: "/images/landing-1.jpg",
    text: "Meet the team that makes it happen",
    link: "Explore",
    contentImage: "/images/kenyaa.jpg",
    currentLink: "/team",
  },
];

export default function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % content.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const current = content[currentIndex];

  return (
    <div className="relative flex flex-col w-full h-screen overflow-hidden">
      {/* blurred background */}
      <div className="absolute inset-0 bg-cover bg-center filter blur-xl scale-110 transition-all duration-1000"
        style={{backgroundImage: `url(${current.images})`}}
      />

      <div className="absolute inset-0 bg-black/40"></div>

      {/* container */}
      <div className="flex flex-col md:flex-row items-end h-full w-full text-white relative z-10">
        
        {/* left section */}
        <div className="flex w-full h-full md:items-center items-center md:justify-start justify-end md:pt-60 md:pl-30 pb-70 md:pb-50 bg-green-300/10 absolute z-10">

          <div className="flex flex-col gap-6 md:gap-6 px-6 md:px-0 w-full max-w-[600px] text-left">
            <h3 className="text-[42px] md:text-[64px] leading-[48px] md:leading-[74px] font-bold transition-all duration-700">
              {current.text}
            </h3>

            <Link href={current.currentLink} className="px-5 py-3 md:px-7 md:py-4 flex items-center justify-center gap-3 bg-secondary text-black font-semibold text-base md:text-xl w-fit">
              {current.link} <ArrowRight className="-rotate-45" />
            </Link>
          </div>
        </div>

        {/* right image section */}
        <div className="flex w-full h-full items-center justify-end">
          {current.contentImage && (
            <ClippedImageShape imageSrc={current.contentImage} />
          )}
        </div>

      </div>
    </div>
  );
}
